<template>
    <div style="padding: 15px;background-color: #fff" >
        <div class="content" >
            <div>
                <el-input placeholder="请输入内容" v-model="searchValue" class="input-with-select">
                    <el-button slot="append"  icon="el-icon-search" @click="search">搜索</el-button>
                </el-input>

<!--                <p>搜索</p>-->
            </div>
            <div class="text-left flex font-14 stitle padding-top">
                <li>搜索历史</li>
                <li @click="delefind">清空</li>
            </div>
            <div class="text-left font-12 findjil padding-top">
                <li class="fl" @click="$router.push({path: '/searchInfo' ,query: {key:Datafind[i]}})" v-for="(item,i) in Datafind" :key="i">
                    {{item}}</li>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "search",
        data(){
            return{
                searchValue:"",
                Datafind:[]
            }
        },
        created(){
            var data = JSON.parse(this.$storage.getLocalStorage('searchKey'))
            console.log(data)
            this.Datafind = data || []
        },
        methods:{
            delefind(){
                this.Datafind = []
                this.$storage.delLocalStorage('searchKey')
            },
            search(){
                var value =this.searchValue
                if(value.length === 0 || value === ''){
                    this.$notify({title: '温馨提示',message: '您好像没有输入要搜索的内容呢！',type: 'warning'});
                    return;
                }
                this.Datafind.push(this.searchValue)
                this.$storage.setLocalStorage('searchKey',JSON.stringify(this.Datafind))
                this.$router.push({path: '/searchInfo' ,query: {key: this.searchValue}})
                this.searchValue = ""
            }
        }
    }
</script>

<style scoped>
    body{
        background-color: #FFFFFF;
    }
    li {
        list-style: none;
        cursor: default;
    }
    .el-input-group__append{
        border: 1px  #fff solid !important;
        border-radius: 20px;
    }

    .el-button {
        background-color: #ff5c38 !important;
        color: #fff !important;
        /*border-radius:  5px 20px 20px 5px;*/
        border: 1px #fff solid !important;
    }
    .content{
        max-width: 1180px;
        /*background-color: #b6b6b6;*/
        height: 100vh;
        margin: 0 auto;
    }
    .stitle > li{
        padding-right: 15px;
    }
    .stitle > li:nth-child(2){
        color: #ff5c38;
    }
    .findjil > li{
        background-color: rgba(239,239,239,1);
        padding: 5px;
        margin: 4px;
        border-radius: 5px;
    }
</style>